import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router/index.js'
import { createPinia } from 'pinia'
import VueCookies from 'vue3-cookies'
// import { Loading } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueApexCharts from 'vue3-apexcharts'

// index.html - CSS
import '../public/assets/stylesheets/theme.css'
import '../public/assets/stylesheets/font-awesome/css/font-awesome.css'

const app = createApp(App)
const pinia = createPinia() // Pinia 생성 및 플러그인 등록

app.use(pinia)
app.use(router)
app.use(VueCookies)
// app.use(Loading)
app.use(VCalendar)
app.use(VueApexCharts)

// v-calendar 3.1.2 내부 DateRangeContext.render() 에러 무시
app.config.errorHandler = (err) => {
  if (err?.message?.includes('dayIndex')) return
  console.error(err)
}

app.use(Toast, {
  transition: 'Vue-Toastification__fade',
  maxToasts: 2,
  newestOnTop: true,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter((t) => t.type === toast.type).length !== 0) {
      // 동일한 유형의 토스트가 이미 존재하면 새 토스트를 표시하지 않음
      return false
    }
    // 해당 조건에 해당하지 않는 경우, 토스트 수정 가능
    return toast
  }
})

app.mount('#app')
